import {
  GET_LEARNER_PROGRESS,
  GET_LEARNER_PROGRESS_SUCCESS,
  GET_LEARNER_PROGRESS_FAILURE,
  TRIGGER_TOAST,
} from "../constants";
import { API, graphqlOperation } from "aws-amplify";
import { GetLearnerProgressDetails } from "./../../queries";

export const getLearnerProgress = (userId: string, productId: number) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_LEARNER_PROGRESS });
    if (!!sessionStorage.getItem("isDemoUser")) {
      let dummyData: any = {};
      if (productId === 57 || productId === 58 || productId === 59 || productId === 60) {
        dummyData = require("../../data/MockData/soloProgressDetails.json");
      }
      if (productId === 56 || productId === 0 || productId === 62 || productId === 63 || productId === 64) {
        dummyData = require("../../data/MockData/getLearnerProgressDetails.json");
      }
      dispatch({ type: GET_LEARNER_PROGRESS_SUCCESS, payload: { ...dummyData } });
    } else {
      const getProgressDetails = API.graphql(graphqlOperation(GetLearnerProgressDetails(userId.toString(), productId, 'learnerSkillProgress'))) as Promise<any>;
      getProgressDetails.then(async (progressDetails: any) => {
        let response = JSON.parse(progressDetails.data.getProgressDetails);
        if (response.statusCode === 200) {
          dispatch({ type: GET_LEARNER_PROGRESS_SUCCESS, payload: { ...response } });
        } else {
          // handleError(err);
          dispatch({ type: GET_LEARNER_PROGRESS_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: "error",
              transMessage: "message_errorDefault",
            },
          });
        }
      }).catch((err: any) => {
        dispatch({ type: GET_LEARNER_PROGRESS_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity: "error",
            transMessage: "message_errorDefault",
          },
        });
      });
    }
  };
};
